// import React, { useEffect, useState } from "react";
// import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
// import { FaSearch } from "react-icons/fa";
// import styles from "./Styles/ElectionPromptTemplate.module.css";

// const ElectionPromptTemplate = () => {
//   const [templates, setTemplates] = useState([]);
//   const [search, setSearch] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [promptName, setPromptName] = useState("");
//   const [promptDescription, setPromptDescription] = useState("");
//   const [type, setType] = useState("custom");
//   const [isLoading, setIsLoading] = useState(false);
//   const [errorMsg, setErrorMsg] = useState("");
//   const [successMsg, setSuccessMsg] = useState("");

//   const token = localStorage.getItem("token");

//   // Fetch templates on load
//   useEffect(() => {
//     fetchTemplates();
//   }, []);

//   const fetchTemplates = async () => {
//     if (!token) return setErrorMsg("Missing token. Please log in again.");

//     try {
//       setIsLoading(true);
//       const res = await fetch("https://prod.toxboxai.com/api/prompt-template/get-templates-by-creator", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!res.ok) throw new Error("Failed to fetch templates");
//       const data = await res.json();
//       setTemplates(data.templates || []);
//     } catch (error) {
//       setErrorMsg(error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSave = async () => {
//     setErrorMsg("");
//     setSuccessMsg("");
//     if (!promptName.trim() || !promptDescription.trim()) {
//       return setErrorMsg("Prompt name and description are required.");
//     }

//     try {
//       const url = editingId
//         ? `https://prod.toxboxai.com/api/prompt-template/update-template/${editingId}`
//         : "https://prod.toxboxai.com/api/prompt-template/create-template";

//       const method = editingId ? "PUT" : "POST";
//       const res = await fetch(url, {
//         method,
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           promptName,
//           promptDescription,
//           type,
//         }),
//       });

//       if (!res.ok) throw new Error("Failed to save template");
//       await res.json();
//       setSuccessMsg(editingId ? "Template updated successfully!" : "Template created successfully!");
//       setIsModalOpen(false);
//       resetForm();
//       fetchTemplates();
//     } catch (error) {
//       setErrorMsg(error.message);
//     }
//   };

//   const handleEdit = (template) => {
//     setEditingId(template._id);
//     setPromptName(template.promptName);
//     setPromptDescription(template.promptDescription);
//     setType(template.type);
//     setIsModalOpen(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       const res = await fetch(`https://prod.toxboxai.com/api/prompt-template/delete-template/${id}`, {
//         method: "DELETE",
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!res.ok) throw new Error("Failed to delete template");
//       setTemplates((prev) => prev.filter((t) => t._id !== id));
//     } catch (error) {
//       setErrorMsg(error.message);
//     }
//   };

//   const resetForm = () => {
//     setEditingId(null);
//     setPromptName("");
//     setPromptDescription("");
//     setType("custom");
//   };

//   const filteredTemplates = templates.filter((t) =>
//     t.promptName.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className={styles.container}>
//       <div className={styles.topBar}>
//         <div className={styles.searchBox}>
//           <FaSearch className={styles.searchIcon} />
//           <input
//             type="text"
//             placeholder="Search templates..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//           />
//         </div>
//         <button onClick={() => setIsModalOpen(true)} className={styles.addBtn}>
//           + Add Template
//         </button>
//       </div>

//       {isLoading ? (
//         <p className={styles.loader}>Loading...</p>
//       ) : (
//         <div className={styles.cardGrid}>
//           {filteredTemplates.length > 0 ? (
//             filteredTemplates.map((t) => (
//               <div className={styles.card} key={t._id}>
//                 <h3>{t.promptName}</h3>
//                 <p>
//                   <strong>Type:</strong> {t.type}
//                 </p>
//                 <p>{t.promptDescription}</p>
//                 <div className={styles.cardActions}>
//                   <button
//                     onClick={() => handleEdit(t)}
//                     className={styles.editBtn}
//                     aria-label="Edit Template"
//                   >
//                     <MdOutlineEdit />
//                   </button>
//                   <button
//                     onClick={() => handleDelete(t._id)}
//                     className={styles.deleteBtn}
//                     aria-label="Delete Template"
//                   >
//                     <MdDeleteOutline />
//                   </button>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p className={styles.noData}>No templates found.</p>
//           )}
//         </div>
//       )}

//       {isModalOpen && (
//         <div className={styles.modalOverlay}>
//           <div className={styles.modal}>
//             <h2>{editingId ? "Edit Template" : "Create Template"}</h2>

//             <input
//               type="text"
//               placeholder="Prompt Name"
//               value={promptName}
//               onChange={(e) => setPromptName(e.target.value)}
//             />

//             <select value={type} onChange={(e) => setType(e.target.value)}>
//               <option value="query">Query</option>
//               <option value="promise">Promise</option>
//               <option value="leader">Leader</option>
//               <option value="party">Party</option>
//               <option value="influencer">Influencer</option>
//               <option value="custom">Custom</option>
//             </select>

//             <textarea
//               placeholder="Prompt Description"
//               rows={6}
//               value={promptDescription}
//               onChange={(e) => setPromptDescription(e.target.value)}
//             />

//             {errorMsg && <p className={styles.error}>{errorMsg}</p>}
//             {successMsg && <p className={styles.success}>{successMsg}</p>}

//             <div className={styles.modalActions}>
//               <button onClick={handleSave} className={styles.saveBtn}>
//                 {editingId ? "Update" : "Save"}
//               </button>
//               <button
//                 onClick={() => {
//                   setIsModalOpen(false);
//                   resetForm();
//                 }}
//                 className={styles.cancelBtn}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ElectionPromptTemplate;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import styles from "./Styles/ElectionPromptTemplate.module.css";

const TEMPLATE_TYPES = [
  "custom",
  "promise",
  "query",
  "leader",
  "influencer",
  "advertisement",
];

const ElectionPromptTemplate = () => {
  const [templates, setTemplates] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [promptName, setPromptName] = useState("");
  const [promptDescription, setPromptDescription] = useState("");
  const [type, setType] = useState("custom");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // Fetch templates on load
  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    if (!token) return setErrorMsg("Missing token. Please log in again.");

    try {
      setIsLoading(true);
      const res = await fetch(
        "https://prod.toxboxai.com/api/prompt-template/get-templates-by-creator",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error("Failed to fetch templates");
      const data = await res.json();
      setTemplates(data.templates || []);
    } catch (error) {
      setErrorMsg(error.message);
    } finally {
      setIsLoading(false);
    }
  };


  const handleSave = async () => {
    setErrorMsg("");
    setSuccessMsg("");
    if (!promptName.trim() || !promptDescription.trim()) {
      return setErrorMsg("Prompt name and description are required.");
    }

    try {
      const url = editingId
        ? `https://prod.toxboxai.com/api/prompt-template/update-template/${editingId}`
        : "https://prod.toxboxai.com/api/prompt-template/create-template";

      const method = editingId ? "PUT" : "POST";
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          promptName,
          promptDescription,
          type,
        }),
      });

      if (!res.ok) throw new Error("Failed to save template");
      await res.json();
      setSuccessMsg(editingId ? "Template updated successfully!" : "Template created successfully!");
      setIsModalOpen(false);
      resetForm();
      fetchTemplates();
    } catch (error) {
      setErrorMsg(error.message);
    }
  };

  const handleEdit = (e, template) => {
    e.stopPropagation();
    setEditingId(template._id);
    setPromptName(template.promptName);
    setPromptDescription(template.promptDescription);
    setType(template.type);
    setIsModalOpen(true);
  };

  const handleDelete = async (e, id) => {
    e.stopPropagation();
    try {
      const res = await fetch(
        `https://prod.toxboxai.com/api/prompt-template/delete-template/${id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error("Failed to delete template");
      setTemplates((prev) => prev.filter((t) => t._id !== id));
    } catch (error) {
      setErrorMsg(error.message);
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setPromptName("");
    setPromptDescription("");
    setType("custom");
  };

  const truncateDescription = (text) => {
    const words = text.split(" ");
    return words.length > 25 ? words.slice(0, 25).join(" ") + "..." : text;
  };

  const filteredTemplates = templates.filter((t) =>
    t.promptName.toLowerCase().includes(search.toLowerCase())
  );

  const handlePromptClick = (prompt) => {
    navigate("/election/create-agent", {
      state: { selectedPromptId: prompt._id, selectedPromptName: prompt.promptName },
    });
  };

  const handleOpenCreateModal = () => {
    resetForm();
    setIsModalOpen(true);
  };

  return (
    <div className={styles.container}>
      {/* <div className={styles.topBar}>
        <div className={styles.searchBox}>
          <FaSearch className={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search templates..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <button onClick={handleOpenCreateModal} className={styles.addBtn}>
          + Add Template
        </button>
      </div> */}

      {isLoading ? (
        <p className={styles.loader}>Loading templates...</p>
      ) : (
        <div className={styles.cardGrid}>
          {filteredTemplates.length > 0 ? (
            filteredTemplates.map((t) => (
              <div
                className={styles.card}
                key={t._id}
                onClick={() => handlePromptClick(t)}
              >
                <h3>{t.promptName}</h3>
                <p>
                  <strong>Type:</strong> {t.type.charAt(0).toUpperCase() + t.type.slice(1)}
                </p>
                <p>{truncateDescription(t.promptDescription)}</p>

                <div className={styles.cardActions}>
                  <button
                    onClick={(e) => handleEdit(e, t)}
                    className={styles.editBtn}
                    aria-label="Edit Template"
                    title="Edit"
                  >
                    <MdOutlineEdit />
                  </button>
                  {/* <button
                    onClick={(e) => handleDelete(e, t._id)}
                    className={styles.deleteBtn}
                    aria-label="Delete Template"
                    title="Delete"
                  >
                    <MdDeleteOutline />
                  </button> */}
                </div>
              </div>
            ))
          ) : (
            <p className={styles.noData}>No templates found.</p>
          )}
        </div>
      )}

      {isModalOpen && (
        <div className={styles.modalOverlay} onClick={() => setIsModalOpen(false)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <h2>{editingId ? "Edit Template" : "Create New Template"}</h2>

            <label>Prompt Name</label>
            <input
              type="text"
              placeholder="Enter prompt name"
              value={promptName}
              onChange={(e) => setPromptName(e.target.value)}
            />

            <label>Type</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              {TEMPLATE_TYPES.map((t) => (
                <option key={t} value={t}>
                  {t.charAt(0).toUpperCase() + t.slice(1)}
                </option>
              ))}
            </select>

            <label>Prompt Description</label>
            <textarea
              placeholder="Enter detailed prompt description..."
              rows={8}
              value={promptDescription}
              onChange={(e) => setPromptDescription(e.target.value)}
            />

            {errorMsg && <p className={styles.error}>{errorMsg}</p>}
            {successMsg && <p className={styles.success}>{successMsg}</p>}

            <div className={styles.modalActions}>
              <button onClick={handleSave} className={styles.saveBtn}>
                {editingId ? "Update" : "Create"}
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  resetForm();
                  setErrorMsg("");
                  setSuccessMsg("");
                }}
                className={styles.cancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ElectionPromptTemplate;